import application from 'application/application';

import template from './list.template.html';

import controller from './list.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider
			.state('root.default.movements.list', {
				url: '/movimentacoes',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			})
			.state('root.default.movements.list1', {
				url:
					'/movimentacoes/todas-conta?dataInicial&dataFinal&diario&palavraChave&lido&caderno&tipo',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			})
			.state('root.default.movements.list2', {
				url:
					'/movimentacoes/publicacoes?dataInicial&dataFinal&diario&palavraChave&lido&caderno&pesquisa',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			})
			.state('root.default.movements.list3', {
				url:
					'/movimentacoes/publicacoes/pastas?pasta&folderType&dataInicial&dataFinal&diario&caderno&palavraChave&lido&pesquisa',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			})
			.state('root.default.movements.list4', {
				url:
					'/movimentacoes/processos/pastas?pasta&dataInicial&dataFinal&fonte&identificador&orgaoJudicial&valorParametro&lido&composedId',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			})
			.state('root.default.movements.list5', {
				url:
					'/movimentacoes/lixeira?&dataInicial&dataFinal&diario&palavraChave&lido&caderno&tipo',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			});
	}
]);
